import { EventTouch, Node, UITransform, v2, v3, Vec2 } from 'cc';

namespace Gesture {
    export namespace Click {
        /**
         * 判斷手勢的開始與結束位置偏差是否小於 offset，若是的話則屬於點擊手勢
         * @param event 事件
         * @param offset 開始與結束位置的可容忍偏差
         * @returns 是否屬於點擊手勢
         */
        export function isClick(event: EventTouch, offset: Vec2) {
            const startLocation = event.getStartLocation();
            const currentLocation = event.getLocation();
            return Math.abs(currentLocation.x - startLocation.x) <= offset.x && Math.abs(currentLocation.y - startLocation.y) <= offset.y;
        }
        /**
         * 點擊是否位於目標內
         * @param event 事件
         * @param target 目標(default: 事件目標)
         */
        export function insideTarget(event: EventTouch, target?: Node, position?: Vec2) {
            const touchPosition = position ?? event.getUILocation();
            const currentTarget = target ?? (event.currentTarget as Node);
            const pos = currentTarget.parent.getComponent(UITransform).convertToNodeSpaceAR(v3(touchPosition.x, touchPosition.y));
            return currentTarget.getComponent(UITransform).getBoundingBox().contains(v2(pos.x, pos.y));
        }
    }
    export namespace Scroll {
        /**
         * 判斷手勢的開始與結束位置偏差是否符合 offset 且距離超過 distance，若是的話則屬於下滑手勢
         * @param event 事件
         * @param offsetY 最小垂直位移量 (endPositionY - startPositionY)
         * @param distance 滑動距離最小值
         * @returns 是否屬於下滑手勢
         */
        export function isScrollDown(event: EventTouch, offsetY: number, distance: number): boolean {
            const startLocation = event.getStartLocation();
            const currentLocation = event.getLocation();
            return currentLocation.y - startLocation.y <= offsetY && Vec2.distance(startLocation, currentLocation) > distance;
        }
    }
}

export default Gesture;
